/*
 * @Author: Han
 * @Date: 2022-01-18 10:02:34
 * @LastEditors: Han
 * @LastEditTime: 2022-05-10 15:25:39
 * @FilePath: \yooshare\console\src\http\moudules\messageManagement.js
 */
import axios from '../axios'

export const replyList = (data) => {
  return axios({
    url: '/auto/reply/list',
    method: 'GET',
    data
  })
}
export const getReplyList = (data) => {
  return axios({
    url: '/auto/reply/more',
    method: 'GET',
    data
  })
}
export const addReply = (data) => {
  return axios({
    url: '/auto/reply/insert',
    method: 'POST',
    data
  })
}
export const updateReply = (data) => {
  return axios({
    url: '/auto/reply/update',
    method: 'POST',
    data
  })
}
export const delReply = (data) => {
  return axios({
    url: '/auto/reply/delete',
    method: 'POST',
    data
  })
}
export const shiftReply = (data) => {
  return axios({
    url: '/auto/reply/shift',
    method: 'POST',
    data
  })
}

// 客服管理模块
export const customerList = () => {
  return axios({
    url: '/customer/page',
    method: 'GET'
  })
}

export const noneCustomerList = () => {
  return axios({
    url: '/customer/except/list',
    method: 'GET'
  })
}

export const delCustomer = (data) => {
  return axios({
    url: '/customer/delete',
    method: 'POST',
    data
  })
}

export const addCustomer = (data) => {
  return axios({
    url: '/customer/insert',
    method: 'POST',
    data
  })
}

// 客服统计
export const getAllNum = (data) => {
  return axios({
    url: '/work_order_board/over_view_census/get_by_time',
    method: 'GET',
    data
  })
}
// 工单量折线图
export const getBorderObj = (data) => {
  return axios({
    url: '/work_order_board/line_chart_work_order/get_by_time',
    method: 'GET',
    data
  })
}
// 管控台客服数据
export const consumerList = (data) => {
  return axios({
    url: '/consumer_board/list',
    method: 'GET',
    data
  })
}
// 管控台消息折线图数据
export const getMessageObj = (data) => {
  return axios({
    url: '/work_order_board/line_chart_message/get_by_time',
    method: 'GET',
    data
  })
}

// 历史工单数据
export const historyWorkOrder = (data) => {
  return axios({
    url: '/work_order_board/history_work_order',
    method: 'GET',
    data
  })
}
// 所有客服列表
export const customerOptionList = (data) => {
  return axios({
    url: '/customer/list',
    method: 'GET',
    data
  })
}
// 工单详情
export const workOrderDetail = (data) => {
  return axios({
    url: '/work_order_board/work_order_detail',
    method: 'GET',
    data
  })
}
// 接入详情
export const joinWorkOrder = (data) => {
  return axios({
    url: '/work_order_board/join_work_order',
    method: 'POST',
    data
  })
}
// 获取当前环境
export const getDomain = (data) => {
  return axios({
    url: '/con/common/getDomain',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/messageManagement.js